// Tabela de clientes do ERP, sobre o DatagridComponent (DataGrid do MUI).
//
// A tabela recebe APENAS a página atual, já filtrada e ordenada pelo servidor,
// por isso paginação e ordenação são controladas de fora (modo "server"):
// trocar de página ou clicar num cabeçalho avisa a tela, que refaz a busca.
//
// A seleção vive fora dos dados e guarda `codigoClient`, não a linha inteira.
// `keepNonExistentRowsSelected` é o que a faz sobreviver à troca de página, já
// que as linhas das outras páginas nem estão em memória.
import { useMemo } from "react";
import { Box } from "@mui/material";
import DatagridComponent from "../../../../../components/datagridComponent";

// O DataGrid da versão MIT não aceita páginas com mais de 100 linhas.
const OPCOES_LINHAS_POR_PAGINA = [25, 50, 100];

const codigoDe = (linha) => String(linha?.codigoClient ?? "");

export default function TabelaClientesErp({
  rows = [],
  columns = [],
  loading = false,
  total = 0,
  pagina = 0,
  onPaginaChange = () => {},
  linhasPorPagina = 100,
  onLinhasPorPaginaChange = () => {},
  ordenacao = { coluna: null, direcao: "asc" },
  onOrdenacaoChange = () => {},
  selecionados = new Set(),
  onSelecionadosChange = () => {},
  selecaoTotal = false,
  height = "68vh",
}) {
  // Com "todos os resultados" ligado, a página inteira aparece marcada: o
  // usuário selecionou um conjunto maior do que o que está à vista. Mexer numa
  // linha nesse modo devolve a seleção explícita desta página sem a linha
  // clicada; desmarcar o cabeçalho limpa tudo.
  const modeloSelecao = useMemo(
    () => (selecaoTotal ? rows.map(codigoDe) : [...selecionados]),
    [rows, selecionados, selecaoTotal],
  );

  const modeloOrdenacao = useMemo(
    () =>
      ordenacao?.coluna
        ? [{ field: ordenacao.coluna, sort: ordenacao.direcao }]
        : [],
    [ordenacao],
  );

  return (
    <Box sx={{ width: "100%", height }}>
      <DatagridComponent
        rows={rows}
        columns={columns}
        loading={loading}
        isPagination
        options={{
          getRowId: codigoDe,
          pageSizeOptions: OPCOES_LINHAS_POR_PAGINA,

          paginationMode: "server",
          rowCount: total,
          paginationModel: { page: pagina, pageSize: linhasPorPagina },
          onPaginationModelChange: (modelo) => {
            if (modelo.pageSize !== linhasPorPagina) {
              onLinhasPorPaginaChange(modelo.pageSize);
            } else {
              onPaginaChange(modelo.page);
            }
          },

          sortingMode: "server",
          sortModel: modeloOrdenacao,
          onSortModelChange: (modelo) =>
            onOrdenacaoChange({
              coluna: modelo[0]?.field || null,
              direcao: modelo[0]?.sort || "asc",
            }),

          // O checkbox do cabeçalho marca/desmarca só a página atual e preserva
          // o que foi selecionado nas outras.
          checkboxSelection: true,
          keepNonExistentRowsSelected: true,
          rowSelectionModel: modeloSelecao,
          onRowSelectionModelChange: (modelo) =>
            onSelecionadosChange(new Set(modelo.map(String))),
        }}
      />
    </Box>
  );
}
